import Modal from "./modal";
import Table from "./table";
import Tabs from "./tabs";
import SchemaImport from "./schemaImport";

export default {
    Modal,
    Table,
    Tabs,
    SchemaImport
}